var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInformationCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3.208a6.792 6.792 0 1 0 0 13.584 6.792 6.792 0 0 0 0-13.584M1.792 10a8.208 8.208 0 1 1 16.417 0 8.208 8.208 0 0 1-16.417 0m7.5-3.333c0-.392.317-.709.708-.709h.009a.708.708 0 0 1 0 1.417H10a.71.71 0 0 1-.708-.708M8.459 10c0-.391.317-.708.708-.708H10c.392 0 .709.317.709.708v2.625h.125a.708.708 0 1 1 0 1.417H10a.71.71 0 0 1-.708-.709v-2.625h-.125A.71.71 0 0 1 8.459 10",
  clipRule: "evenodd"
})));
export default SvgInformationCircle;